import { RequestManager } from "@app/kit";

function getApiHost() {
  if (document.location.hostname === "localhost") return "http://localhost:8000";
  return "";
}

export const api = new RequestManager(getApiHost() + "/api");

// Токен приходит только куками — своего экрана входа у приложения нет.
api.beforeRequestMiddleware.push(({ config }) => {
  config.withCredentials = true;
});

// Access-токен протух — один раз пробуем продлить сессию и повторяем запрос.
// Не помогло: пользователь пришёл сюда не через ссылку из приложения.
api.errorMiddleware.push(async ({ error, shareData, makeRequest }) => {
  if (error.data.statusCode !== 401 || shareData.refreshTried) return error;
  shareData.refreshTried = true;

  const refreshed = await fetch(`${api.getBaseUrl()}/v1/auth/refresh`, {
    method: "POST",
    credentials: "include",
  });
  if (!refreshed.ok) return error;

  // Возвращаем сам объект { requestData, axiosResponse } — createRequest достаёт
  // из него axiosResponse.data и десериализует entity так же, как при обычном успехе.
  const [result] = await makeRequest();
  if (!result) return error;
  return result;
});
